import React from 'react';
import {CircularProgress, Grid, Paper, Typography} from "@material-ui/core";
import CurrencyField from "../Fields/CurrencyField";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";
import setDate from '../../utils/setDate';
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import {Alert} from "@material-ui/lab";

const ApiResultInformationShortForm = ({apiRequestId, apiRequestDateCreated, campaign, portfolio, servicer}) => {
    const classes = useStyles();

    const {loading, error, data} = useQuery(gql`
        query ApiResult($apiRequestId: UUID!, $apiRequestDateCreated: String!) {
            apiResult(apiRequestId: $apiRequestId, apiRequestDateCreated: $apiRequestDateCreated) {
                entityId
                requestReceived
                processCompleted
                processTime
                campaign{
                    id
                    name
                }
                portfolio{
                    id
                    name
                }
                servicer{
                    id
                    name
                }
                status
                billed
                payout
                redirectUrl
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
            apiRequestDateCreated: apiRequestDateCreated,
        },
        context: {
            clientName: "kgraphql"
        }
    });

    const apiResult = data?.apiResult ?? {}

    if (loading) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left">Processing Result</Typography>
                <Paper className={classes.paper}>
                    <CircularProgress color="inherit"/>
                </Paper>
            </>
        );
    }

    if (!apiResult || error) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left">Processing Result</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left">Processing Result</Typography>

            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={2} lg={3}>
                        <TextField label="Status" value={apiResult.status}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Request received at"
                                   value={apiResult.requestReceived && setDate(apiResult.requestReceived)}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={3}>
                        <TextField label="Processing time" value={`${apiResult.processTime} sec`}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <TextField label="Process completed at"
                                   value={apiResult.processCompleted && setDate(apiResult.processCompleted)}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={1}>
                        <CurrencyField label="Billed" value={apiResult.billed}/>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={1}>
                        <CurrencyField label="Payout" value={apiResult.payout}/>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <TextField
                            label="Campaign"
                            value={`${apiResult.campaign ? apiResult.campaign.name + ' - ' + apiResult.campaign.id : ''}`}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} lg={3}>
                        <TextField
                            label="Portfolio"
                            value={`${apiResult.portfolio ? apiResult.portfolio.name + ' - ' + apiResult.portfolio.id : ''}`}
                        />
                    </Grid>
                    <Grid item xs={12} md={3} lg={4}>
                        <TextField
                            label="Servicer"
                            value={`${apiResult.servicer ? apiResult.servicer.name + ' - ' + apiResult.servicer.id : ''}`}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
};

export default ApiResultInformationShortForm;
